/**
 * File: FileUploadField.js
 * Origin: isotect
 * Description: FileUploadField component for forms.
 *
 * Version: v2.0.0
 * Created: 2026-01-07
 * Last Updated: 2026-01-21
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Icons
import { AiOutlineCloudUpload } from "react-icons/ai";
import { MdClear } from "react-icons/md";

/**
 * @param {*} param0
 * @returns
 */
function FileUploadField({ label, formats, maxSize, files, setFiles }) {
    const handleFileChange = (event) => {
        const selectedFiles = event.target.files;
        if (selectedFiles && selectedFiles.length > 0) {
            const newFiles = Array.from(selectedFiles);
            setFiles((prevFiles) => [...prevFiles, ...newFiles]);
        }
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const droppedFiles = event.dataTransfer.files;
        if (droppedFiles.length > 0) {
            const newFiles = Array.from(droppedFiles);
            setFiles((prevFiles) => [...prevFiles, ...newFiles]);
        }
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };

    const handleRemoveFile = (index) => {
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };

    return (
        <>
            <div className="file-upload-field">
                <label htmlFor="file">{label}</label>
                <div
                    className={`file-upload-field__uploader ${
                        files.length > 0 ? "file-upload-field--active" : null
                    }`}
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                >
                    <div className="file-upload-field__instructions">
                        <AiOutlineCloudUpload />
                        <div className="file-upload-field__container1">
                            <div className="file-upload-field__container2">
                                <label htmlFor="browse" className="browse-btn">
                                    Click to upload
                                </label>
                                <input
                                    type="file"
                                    hidden
                                    id="browse"
                                    onChange={handleFileChange}
                                    accept=".pdf, .jpg, .png"
                                    multiple
                                />
                                <p>or drag and drop files</p>
                            </div>
                            <p className="file-upload-field__information">
                                Supported formats: PDF, JPG, PNG
                            </p>
                            <p className="file-upload-field__information">
                                Maximum file size of 20MB
                            </p>
                        </div>
                    </div>
                </div>
                {files.length > 0 && (
                    <div className="file-upload-field__file-list">
                        {files.map((file, index) => (
                            <FileItem
                                key={index}
                                name={file.name}
                                size={file.size}
                                onRemove={() => handleRemoveFile(index)}
                            />
                        ))}
                    </div>
                )}
                {files.length > 0 && (
                    <div className="success-file">
                        <p>{files.length} file(s) uploaded</p>
                    </div>
                )}
            </div>
        </>
    );
}

function FileItem({ name, size, onRemove }) {
    let fileSize;
    let fileUnits = "B";

    if (size > 1024) {
        fileSize = (size / 1024).toFixed(2);
        fileUnits = "KB";
    } else if (size > 1024 * 1024) {
        fileSize = (size / (1024 * 1024)).toFixed(2);
        fileUnits = "MB";
    }

    return (
        <>
            <div className="file-item">
                <div className="file-item__info">
                    <p>{name}</p>
                    <p>{`${fileSize} ${fileUnits}`}</p>
                </div>
                <div className="file-item__actions">
                    <MdClear onClick={onRemove} />
                </div>
            </div>
        </>
    );
}

export default FileUploadField;
